import PMA from './PMA'
import config from '@/config'

export default {
  pma: new PMA(config.pma)
}


// WEBPACK FOOTER //
// ./src/lib/index.js